import zsmLayout from '@/zsm-layout/index'

const courseCRouter = {
  path: '/dist',
  component: zsmLayout,
  name: 'distribution',
  redirect: '/dist/list',
  children: [
    {
      meta: { title: '分销数据 ' },
      path: '/dist/index',
      component: () => import('@/view/distribution/index'),
      name: 'distindex'
    },
    {
      meta: { title: '添加推广达人' },
      path: '/dist/add',
      component: () => import('@/view/distribution/add'),
      name: 'distadd'
    },
    {
      meta: { title: '添加现销普通达人' },
      path: '/dist/common',
      component: () => import('@/view/distribution/common'),
      name: 'distcommon'
    },

    {
      meta: { title: '发布达人推广通过 ' },
      path: '/dist/createpopularize',
      component: () => import('@/view/distribution/createpopularize'),
      name: 'popularizeIndex'
    },
    {
      meta: { title: '我的通告 ' },
      path: '/dist/popularize',
      component: () => import('@/view/distribution/popularize'),
      name: 'popularizeIndex'
    },
    {
      meta: { title: '通告接单管理 ' },
      path: '/dist/popularizelist',
      component: () => import('@/view/distribution/popularizelist'),
      name: 'popularizelist'
    },
    {
      meta: { title: '达人管理 ' },
      path: '/dist/list',
      component: () => import('@/view/distribution/list'),
      name: 'distlist'
    },
    {
      meta: { title: '佣金订单规则说明 ' },
      path: '/dist/fee',
      component: () => import('@/view/distribution/fee'),
      name: 'distlist'
    }
  ]
}

export default courseCRouter
